module.exports = __webpack_public_path__ + "img/Bottone-Riepilogo-Interventi.92c27459.jpg";